import { Injectable } from "@angular/core";
import {
    IS_FIRST_CONNECTION_STORAGE_KEY,
    INITIATIVE_PRIORITIES_FILTER_STORAGE_KEY,
    INITIATIVE_PRIORITIES_BY_TYPE_FILTER_STORAGE_KEY,
    INITIATIVE_SORTING_PRIORITY_FILTER_STORAGE_KEY,
    FEASIBILITY_CONSUMPTION_OR_EMISSION_FILTER_STORAGE_KEY,
    TYPE_OF_USE_BY_PROVIDER_ENERGY_STORAGE_KEY,
    TYPE_OF_USE_BY_PROVIDER_CARBON_STORAGE_KEY,
    EMISSION_FACTOR_PROVIDER_FOR_ENERGY_KEY,
    EMISSION_FACTOR_PROVIDER_FOR_CARBON_KEY,
    PREVIOUS_PERIMETERS,
    SELECTED_PERIMETERS
} from "./constants";


@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor() { }

    public static resetLocalStorage(): void {
        const localStorageKeys: string[] = [
            IS_FIRST_CONNECTION_STORAGE_KEY,
            INITIATIVE_PRIORITIES_FILTER_STORAGE_KEY,
            INITIATIVE_PRIORITIES_BY_TYPE_FILTER_STORAGE_KEY,
            INITIATIVE_SORTING_PRIORITY_FILTER_STORAGE_KEY,
            FEASIBILITY_CONSUMPTION_OR_EMISSION_FILTER_STORAGE_KEY,
            FEASIBILITY_CONSUMPTION_OR_EMISSION_FILTER_STORAGE_KEY,
            TYPE_OF_USE_BY_PROVIDER_ENERGY_STORAGE_KEY,
            TYPE_OF_USE_BY_PROVIDER_CARBON_STORAGE_KEY,
            EMISSION_FACTOR_PROVIDER_FOR_ENERGY_KEY,
            EMISSION_FACTOR_PROVIDER_FOR_CARBON_KEY,
            SELECTED_PERIMETERS,
            PREVIOUS_PERIMETERS,
        ];
        localStorageKeys.forEach((key: string) => localStorage.removeItem(key));
    }
}